import {useState, useCallback} from 'react'
import {useRails} from '~/react/contexts/rails'

import {fetchQantasMembershipPrepopulationData} from '../../../../api'

const useFetchPrepopulationData = () => {
  const [isFetching, setIsFetching] = useState(false)
  const [prePopulationData, setPrePopulationData] = useState(null)
  const {currentSupplier} = useRails()

  const fetchData = useCallback(async () => {
    setIsFetching(true)

    try {
      const response = await fetchQantasMembershipPrepopulationData({
        supplierId: currentSupplier.id,
      })

      const data = response.prepopulationData
      setPrePopulationData(data)
    } finally {
      setIsFetching(false)
    }
  }, [currentSupplier.id])

  return {
    prePopulationData,
    fetch: fetchData,
    isFetching,
  }
}

export default useFetchPrepopulationData
